import angular from 'angular';

import '../activity/activity.scss';

export default angular.module('unit.payment', ['ngResource']);
